import type { ReactNode } from 'react';

export const symbol_power_settings_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM721-239q99-99 99-241t-99-241q-99-99-241-99t-241 99q-99 99-99 241t99 241q99 99 241 99t241-99Zm-71-71q70-70 70-170 0-38-11.5-73.5T677-618q-10-14-22.5-15.5T632-629q-10 6-13.5 17.5T623-589q17 23 27 50.5t10 58.5q0 75-52.5 127.5T480-300q-75 0-127.5-52.5T300-480q0-31 9.5-58t26.5-50q8-11 4.5-22T328-627q-9-6-22-5.5T283-618q-21 29-32 64.5T240-480q0 100 70 170t170 70q100 0 170-70ZM458.5-711.5Q450-703 450-690v180q0 13 8.5 21.5T480-480q13 0 21.5-8.5T510-510v-180q0-13-8.5-21.5T480-720q-13 0-21.5 8.5ZM480-480Z"
		/>
	</svg>
);
